<soft-input
  [(value)]="_value"
  (focus)="searchFocused.set(true)"
  placeholder="Suchbegriff eingeben..."
  changeTrigger="blur"
  (valueChange)="search()"
></soft-input>
@if (
  (searchFocused() && sortedLastSearchResults()?.length !== 0 && !_value()) ||
  (!_value() && sortedLastSearchResults()?.length !== 0)
) {
  <div
    class="flex flex-col gap-1 border-b border-r border-l border-[#b7cae0] px-3 py-1 text-sm absolute left-0 right-0 w-full"
  >
    <div class="flex justify-between">
      <p class="text-[#9ca3af]">Letzte Suchanfragen:</p>
      <button class="text-primary cursor-pointer" (click)="deleteAllFn()?.()">
        Alle löschen
      </button>
    </div>
    @for (e of sortedLastSearchResults(); track e.key) {
      <div
        class="justify-between flex cursor-pointer"
        (click)="_value.set(e.body.text); search()"
      >
        <p>{{ e.body.text }}</p>
        <p class="text-light">{{ e.createdAt | date: 'short' }}</p>
      </div>
    }
  </div>
}
